(function () {
  'use strict';

  var config = window.facettWishlistConfig || {};
  var API_BASE = config.apiBase || '/apps/wishlist';
  var WISHLIST_URL = config.wishlistUrl || '/pages/wishlist';
  var LOGIN_URL = config.loginUrl || '/account/login';
  var TIMEOUT_MS = 8000;
  var PENDING_KEY = 'facett_pending_wishlist';

  var state = {
    items: [],
    loaded: false,
    loading: false
  };

  var saleProductHandles = null;
  var saleFetchPromise = null;

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function track(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {});
    }
  }

  function apiFetch(path, options) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () {
      controller.abort();
    }, TIMEOUT_MS);

    return fetch(API_BASE + path, Object.assign({}, options || {}, {
      signal: controller.signal,
      headers: Object.assign({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }, (options && options.headers) || {})
    }))
      .then(function (response) {
        return response.json();
      })
      .finally(function () {
        window.clearTimeout(timer);
      });
  }

  function getVariantIdFromProductForm(root) {
    var scopes = [];
    var node = root;

    while (node && node !== document) {
      scopes.push(node);
      node = node.parentElement;
    }
    scopes.push(document);

    for (var i = 0; i < scopes.length; i++) {
      var input = scopes[i].querySelector(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );
      if (!input || !input.value) {
        continue;
      }
      var id = parseInt(input.value, 10);
      if (Number.isFinite(id) && id > 0) {
        return id;
      }
    }

    return null;
  }

  function isLoggedIn() {
    return config.loggedIn === true;
  }

  function savePending(payload) {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(payload));
    } catch (error) {
      /* ignore */
    }
  }

  function readPending() {
    try {
      var raw = localStorage.getItem(PENDING_KEY);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function clearPending() {
    try {
      localStorage.removeItem(PENDING_KEY);
    } catch (error) {
      /* ignore */
    }
  }

  function setCountBadge(count) {
    var bubble = document.getElementById('wishlist-count-bubble');
    if (!bubble) {
      return;
    }
    var value = bubble.querySelector('[aria-hidden="true"]');
    if (!value) {
      return;
    }
    if (!count || count <= 0) {
      bubble.classList.add('hidden');
      value.textContent = '0';
      return;
    }
    bubble.classList.remove('hidden');
    value.textContent = String(count > 99 ? '99+' : count);
  }

  function updateAmazonVariantIds() {
    var variantId = getVariantIdFromProductForm(document);
    if (!variantId) {
      return;
    }
    document.querySelectorAll('.js-amazon-link').forEach(function (link) {
      link.dataset.variantId = String(variantId);
    });
  }

  function updateButtons() {
    var variantIds = state.items.map(function (item) {
      return Number(item.variant_id);
    });

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var variantId = getVariantIdFromProductForm(button.closest('.wishlist-button-wrap') || document);
      var active = variantId && variantIds.indexOf(variantId) !== -1;
      button.classList.toggle('is-active', !!active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = button.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = active ? 'お気に入りから削除' : 'お気に入りに追加';
      }
    });

    updateAmazonVariantIds();
  }

  function setButtonLoading(button, loading) {
    if (!button) {
      return;
    }
    button.disabled = !!loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function fetchList() {
    if (!isLoggedIn()) {
      state.items = [];
      state.loaded = true;
      setCountBadge(0);
      updateButtons();
      return Promise.resolve([]);
    }

    if (state.loading) {
      return Promise.resolve(state.items);
    }

    state.loading = true;

    return apiFetch('/list', { method: 'GET' })
      .then(function (data) {
        if (!data || !data.ok) {
          throw new Error((data && data.message) || 'Failed to load wishlist.');
        }
        state.items = Array.isArray(data.items) ? data.items : [];
        state.loaded = true;
        setCountBadge(state.items.length);
        updateButtons();
        dispatch('facett:wishlist:updated', { items: state.items.slice() });
        return state.items;
      })
      .catch(function () {
        state.loaded = true;
        return state.items;
      })
      .finally(function () {
        state.loading = false;
      });
  }

  function addItem(payload) {
    return apiFetch('/add', {
      method: 'POST',
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || !data.ok) {
        throw new Error((data && data.message) || 'Failed to add wishlist item.');
      }
      state.items = Array.isArray(data.items) ? data.items : state.items;
      setCountBadge(state.items.length);
      updateButtons();
      dispatch('facett:wishlist:updated', { items: state.items.slice() });
      track('add_to_wishlist', {
        item_id: String(payload.variant_id),
        item_name: payload.handle
      });
      return data;
    });
  }

  function removeItem(variantId) {
    return apiFetch('/remove', {
      method: 'POST',
      body: JSON.stringify({ variant_id: variantId })
    }).then(function (data) {
      if (!data || !data.ok) {
        throw new Error((data && data.message) || 'Failed to remove wishlist item.');
      }
      state.items = Array.isArray(data.items) ? data.items : state.items;
      setCountBadge(state.items.length);
      updateButtons();
      dispatch('facett:wishlist:updated', { items: state.items.slice() });
      track('remove_from_wishlist', {
        item_id: String(variantId)
      });
      return data;
    });
  }

  function recordAmazonClick(payload) {
    if (!isLoggedIn()) {
      return Promise.resolve();
    }
    return apiFetch('/amazon-click', {
      method: 'POST',
      body: JSON.stringify(payload)
    }).catch(function () {
      /* fire-and-forget */
    });
  }

  function redirectToLogin() {
    track('wishlist_login_prompt', {});
    window.location.href = LOGIN_URL || '/account/login';
  }

  function toggleWishlist(button) {
    var wrap = button.closest('[data-wishlist-root]');
    if (!wrap || button.disabled) {
      return;
    }

    var productId = parseInt(wrap.dataset.productId, 10);
    var handle = wrap.dataset.productHandle || '';
    var variantId = getVariantIdFromProductForm(wrap);

    if (!productId || !handle || !variantId) {
      return;
    }

    var payload = {
      product_id: productId,
      variant_id: variantId,
      handle: handle
    };

    if (!isLoggedIn()) {
      savePending(payload);
      redirectToLogin();
      return;
    }

    var exists = state.items.some(function (item) {
      return Number(item.variant_id) === variantId;
    });

    setButtonLoading(button, true);

    var action = exists ? removeItem(variantId) : addItem(payload);
    action
      .catch(function () {
        button.disabled = true;
      })
      .finally(function () {
        setButtonLoading(button, false);
      });
  }

  function processPendingWishlist() {
    if (!isLoggedIn()) {
      return Promise.resolve();
    }
    var pending = readPending();
    if (!pending || !pending.variant_id) {
      return Promise.resolve();
    }
    clearPending();
    return addItem(pending).catch(function () {
      savePending(pending);
    });
  }

  function bindProductButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      if (button.dataset.bound === 'true') {
        return;
      }
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        toggleWishlist(button);
      });
    });

    document.querySelectorAll('product-form input[name="id"]').forEach(function (input) {
      if (input.dataset.wishlistBound === 'true') {
        return;
      }
      input.dataset.wishlistBound = 'true';
      input.addEventListener('change', updateButtons);
    });
  }

  function bindAmazonLinks() {
    document.querySelectorAll('.js-amazon-link').forEach(function (link) {
      if (link.dataset.bound === 'true') {
        return;
      }
      link.dataset.bound = 'true';
      link.addEventListener('click', function () {
        var variantId = getVariantIdFromProductForm(link) || parseInt(link.dataset.variantId, 10);
        var payload = {
          product_id: parseInt(link.dataset.productId, 10),
          variant_id: variantId,
          handle: link.dataset.handle || '',
          asin: link.dataset.asin || ''
        };
        // GA4 は既存キーイベント link_click_amazon（GTM 等）に任せる。二重計測を避ける。
        recordAmazonClick(payload);
      });
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Product not found');
      }
      return response.json();
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }

  function getFacettSaleConfig() {
    return window.FACETT_SALE || null;
  }

  function calcSalePrice(originalCents, percent) {
    return Math.round(originalCents * (100 - percent) / 100);
  }

  function fetchSaleProductHandles(cfg) {
    if (saleProductHandles) {
      return Promise.resolve(saleProductHandles);
    }
    if (saleFetchPromise) {
      return saleFetchPromise;
    }

    saleFetchPromise = fetch('/collections/' + cfg.collectionHandle + '/products.json?limit=250')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        saleProductHandles = (data.products || []).map(function (product) {
          return product.handle;
        });
        return saleProductHandles;
      })
      .catch(function () {
        saleProductHandles = [];
        return saleProductHandles;
      });

    return saleFetchPromise;
  }

  function fetchSaleContext() {
    var cfg = getFacettSaleConfig();
    if (!cfg || !cfg.active || !cfg.percent) {
      return Promise.resolve({ cfg: cfg, handles: [] });
    }
    return fetchSaleProductHandles(cfg).then(function (handles) {
      return { cfg: cfg, handles: handles };
    });
  }

  function getVariantPriceDisplay(variant, productHandle, saleContext) {
    if (!variant || !Number.isFinite(variant.price)) {
      return null;
    }

    var price = variant.price;
    var compareAt = variant.compare_at_price;

    if (compareAt && compareAt > price) {
      return { compareCents: compareAt, saleCents: price, onSale: true };
    }

    var cfg = saleContext && saleContext.cfg;
    var handles = saleContext && saleContext.handles ? saleContext.handles : [];
    if (cfg && cfg.active && cfg.percent > 0 && productHandle && handles.indexOf(productHandle) >= 0) {
      var salePrice = calcSalePrice(price, cfg.percent);
      if (salePrice < price) {
        return { compareCents: price, saleCents: salePrice, onSale: true };
      }
    }

    return { regularCents: price, onSale: false };
  }

  function renderTaxLabelHtml() {
    return '<span class="facett-price__tax fs-5">（税込）</span>';
  }

  function renderDetailsPriceHtml(variant, productHandle, saleContext) {
    var display = getVariantPriceDisplay(variant, productHandle, saleContext);
    if (!display) {
      return '';
    }

    var taxLabel = renderTaxLabelHtml();

    if (display.onSale) {
      return (
        '<div class="cart-item__discounted-prices">' +
          '<span class="visually-hidden">通常価格</span>' +
          '<s class="cart-item__old-price product-option">' + escapeHtml(formatMoney(display.compareCents)) + '</s> ' +
          '<span class="visually-hidden">セール価格</span>' +
          '<strong class="cart-item__final-price product-option">' + escapeHtml(formatMoney(display.saleCents)) + taxLabel + '</strong>' +
        '</div>'
      );
    }

    return '<div class="product-option">' + escapeHtml(formatMoney(display.regularCents)) + taxLabel + '</div>';
  }

  function getProductOptionName(product, index) {
    if (!product || !product.options || !product.options.length) {
      return '';
    }
    var option = product.options[index || 0];
    if (!option) {
      return '';
    }
    if (typeof option === 'string') {
      return option;
    }
    return option.name || '';
  }

  function renderVariantHtml(product, variant) {
    if (!variant || variant.title === 'Default Title') {
      return '';
    }

    var optionName = getProductOptionName(product, 0);

    if (optionName) {
      return (
        '<dl>' +
          '<div class="product-option">' +
            '<dt>' + escapeHtml(optionName) + ': </dt>' +
            '<dd>' + escapeHtml(variant.title) + '</dd>' +
          '</div>' +
        '</dl>'
      );
    }

    return '<div class="product-option">' + escapeHtml(variant.title) + '</div>';
  }

  function renderWishlistActionsHtml(variantId, url) {
    return (
      '<div class="wishlist-item__actions-inner">' +
        '<a href="' + escapeHtml(url) + '" class="button button--secondary wishlist-item__view" data-wishlist-item-link>商品ページを見る</a>' +
        '<button type="button" class="button button--tertiary wishlist-item__remove" data-wishlist-remove="' + escapeHtml(variantId) + '">お気に入りから削除</button>' +
      '</div>'
    );
  }

  function setWishlistLoading(root, loading) {
    var itemsEl = root.querySelector('[data-wishlist-items]');
    var overlay = root.querySelector('[data-wishlist-loading]');
    if (itemsEl) {
      itemsEl.classList.toggle('is-loading', !!loading);
    }
    if (overlay) {
      overlay.hidden = !loading;
    }
  }

  function updateWishlistCount(root, count) {
    var countEl = root.querySelector('[data-wishlist-count]');
    if (!countEl) {
      return;
    }
    if (!count || count <= 0) {
      countEl.hidden = true;
      countEl.textContent = '';
      return;
    }
    countEl.hidden = false;
    countEl.textContent = '登録商品：' + count + '件';
  }

  function setWishlistTableVisible(root, visible) {
    var table = root.querySelector('[data-wishlist-table]');
    if (table) {
      table.hidden = !visible;
    }
  }

  function renderWishlistRow(row, saleContext) {
    var item = row.item;
    var product = row.product;
    var productHandle = product ? product.handle : item.handle;
    var variant = product && product.variants
      ? product.variants.find(function (entry) {
          return Number(entry.id) === Number(item.variant_id);
        })
      : null;
    var image = variant && variant.featured_image
      ? variant.featured_image.src
      : (product && product.featured_image ? product.featured_image : '');
    var title = product ? product.title : item.handle;
    var url = product
      ? ('/products/' + product.handle + '?variant=' + item.variant_id)
      : ('/products/' + item.handle);
    var soldOut = variant && variant.available === false;
    var actionsHtml = renderWishlistActionsHtml(item.variant_id, url);

    return (
      '<tr class="cart-item wishlist-item" data-wishlist-item data-variant-id="' + escapeHtml(item.variant_id) + '">' +
        '<td class="cart-item__media">' +
          (image
            ? '<a href="' + escapeHtml(url) + '" class="wishlist-item__image-link" data-wishlist-item-link>' +
                '<img src="' + escapeHtml(image) + '" class="cart-item__image" alt="' + escapeHtml(title) + '" loading="lazy" width="120" height="120">' +
              '</a>'
            : '') +
        '</td>' +
        '<td class="cart-item__details">' +
          '<a href="' + escapeHtml(url) + '" class="cart-item__name h4 break wishlist-item__link" data-wishlist-item-link>' + escapeHtml(title) + '</a>' +
          renderDetailsPriceHtml(variant, productHandle, saleContext) +
          renderVariantHtml(product, variant) +
          (soldOut
            ? '<span class="badge wishlist-item__badge">売り切れ</span>'
            : '') +
        '</td>' +
        '<td class="cart-item__quantity medium-hide large-up-hide">' + actionsHtml + '</td>' +
        '<td class="wishlist-item__actions cart-item__totals right small-hide">' + actionsHtml + '</td>' +
      '</tr>'
    );
  }

  function bindWishlistRowEvents(root, listEl) {
    listEl.querySelectorAll('[data-wishlist-item-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('wishlist_item_click', {
          item_id: link.closest('[data-wishlist-item]')
            ? link.closest('[data-wishlist-item]').dataset.variantId
            : ''
        });
      });
    });

    listEl.querySelectorAll('[data-wishlist-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = parseInt(button.getAttribute('data-wishlist-remove'), 10);
        if (!variantId) {
          return;
        }
        var row = button.closest('[data-wishlist-item]');
        if (row) {
          row.classList.add('is-removing');
        }
        button.disabled = true;
        removeItem(variantId)
          .then(function () {
            renderWishlistPage();
          })
          .catch(function () {
            if (row) {
              row.classList.remove('is-removing');
            }
            button.disabled = false;
          });
      });
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) {
      return;
    }

    var listEl = root.querySelector('[data-wishlist-list]');
    var emptyEl = root.querySelector('[data-wishlist-empty]');
    var errorEl = root.querySelector('[data-wishlist-error]');
    var loginEl = root.querySelector('[data-wishlist-login]');
    var bodyEl = root.querySelector('[data-wishlist-body]');

    if (!isLoggedIn()) {
      if (loginEl) {
        loginEl.hidden = false;
      }
      if (bodyEl) {
        bodyEl.hidden = true;
      }
      if (listEl) {
        listEl.innerHTML = '';
      }
      setWishlistTableVisible(root, false);
      updateWishlistCount(root, 0);
      setWishlistLoading(root, false);
      return;
    }

    if (loginEl) {
      loginEl.hidden = true;
    }
    if (bodyEl) {
      bodyEl.hidden = false;
    }

    track('view_wishlist', {});
    setWishlistLoading(root, true);

    fetchList()
      .then(function (items) {
        if (!listEl) {
          return;
        }

        updateWishlistCount(root, items.length);

        if (!items.length) {
          listEl.innerHTML = '';
          setWishlistTableVisible(root, false);
          if (emptyEl) {
            emptyEl.hidden = false;
          }
          return;
        }

        if (emptyEl) {
          emptyEl.hidden = true;
        }
        if (errorEl) {
          errorEl.hidden = true;
        }
        setWishlistTableVisible(root, true);

        return fetchSaleContext().then(function (saleContext) {
          return Promise.all(items.map(function (item) {
            return fetchProduct(item.handle).then(function (product) {
              return { item: item, product: product };
            }).catch(function () {
              return { item: item, product: null };
            });
          })).then(function (rows) {
            listEl.innerHTML = rows.map(function (row) {
              return renderWishlistRow(row, saleContext);
            }).join('');
            bindWishlistRowEvents(root, listEl);
          });
        });
      })
      .catch(function () {
        setWishlistTableVisible(root, false);
        if (errorEl) {
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        setWishlistLoading(root, false);
      });
  }

  function init() {
    bindProductButtons();
    bindAmazonLinks();

    fetchList()
      .then(function () {
        return processPendingWishlist();
      })
      .finally(function () {
        updateButtons();
        renderWishlistPage();
      });

    document.addEventListener('shopify:section:load', function () {
      bindProductButtons();
      bindAmazonLinks();
      updateButtons();
    });
  }

  window.FacettWishlist = {
    fetchList: fetchList,
    addItem: addItem,
    removeItem: removeItem,
    getItems: function () {
      return state.items.slice();
    },
    refreshPage: renderWishlistPage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
